export const TIPOS_ACT_COSTE_REQUEST = "TIPOS_ACT_COSTE_REQUEST";
export const TIPOS_ACT_COSTE_OK = "TIPOS_ACT_COSTE_OK";
export const TIPOS_ACT_COSTE_ERROR = "TIPOS_ACT_COSTE_ERROR";
